export const portfolioOfferings = [
  {
    mainHeading: "Portfolio Offerings",
    details: [
      {
        heading: "Holding",
        key: "holding",
        value: false,
      },
      {
        heading: "Insights",
        key: "insights",
        value: false,
      },
      {
        heading: "NAV",
        key: "nav",
        value: false,
      },
      {
        heading: "Benchmark Comparison",
        key: "benchmarkComparison",
        value: false,
      },
      {
        heading: "MF Execution",
        key: "mfExecution",
        value: false,
      },
    ],
  },
];

export const microWebsite = [
  {
    mainHeading: "Micro Website",
    details: [
      {
        heading: "RA Support",
        key: "isRaAccess",
        value: false,
      },
      {
        heading: "Published",
        key: "published",
        value: false,
      },
    ],
  },
];
